<!-- 捐款記錄 -->
<template>
  <v-client-table
    v-if="isShow"
    name="donationRecord"
    :data="tableData"
    :columns="tableColumns"
    :options="tableOptions"
  >
    <template #beforeTable>
      <div>
        <input
          v-model="dateFrom"
          type="date"
          placeholder="請選擇起日"
        >
        -
        <input
          v-model="dateTo"
          type="date"
          placeholder="請選擇迄日"
        >
        <Button
          small
          transparent
          @click.native="filterByDateRange"
        >
          查詢
        </Button>
      </div>
    </template>
    <template #reissue="props">
      <button
        v-if="props.row.reissue"
        class="btn"
        :class="$style.link"
        @click="handleResendPaymentReceipt(props.row.reissue)"
      >
        補發電子收據
      </button>
    </template>
  </v-client-table>
</template>

<script>
import { mapActions } from 'vuex';
// components
import Button from '@/components/buttons/Button';

export default {
  components: {
    Button,
  },
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    memberAreaData: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableColumns: {
      type: Array,
      default: () => [],
    },
    tableOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
    };
  },
  computed: {
    isShow() {
      return this.currentTab === 'donationRecord' && this.memberAreaData;
    },
  },
  methods: {
    async handleResendPaymentReceipt(id) {
      const result = await this.resendPaymentReceipt(id);
      if(result) {
        alert('電子收據將發送至您的電子信箱，謝謝！');
      }
    },
    filterByDateRange() {
      if(!this.dateFrom || !this.dateTo) {
        return;
      }
      this.$store.commit('donationRecord/SET_CUSTOM_FILTER', {
        filter: 'filterByDateRange',
        value: {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        },
      });
    },
    ...mapActions('member', [
      'resendPaymentReceipt',
    ]),
  },
};
</script>

<style lang="scss" module>
.link {
  color: $red;
}
</style>
